var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';
import { Logger, I18nService } from '@app/core';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { UtilService } from './utility/util.service';
import { UserService } from "@app/user.service";
import { AuthService } from "@app/auth.service";
import { SocketioService } from './socketio.service';
var log = new Logger('App');
var AppComponent = /** @class */ (function () {
    function AppComponent(router, activatedRoute, titleService, translateService, i18nService, util, user, Auth, socketService, idle, keepalive) {
        //subscribe for socket receive data
        //this._subscription = this.socketService.caller.subscribe((data: any) => {
        //if(data && data["user"] == sessionStorage.getItem("user")){
        //  this.chatbotNoti = data["noti"]["chatbotNoti"]
        //this.socialNoti = data["noti"]["socialNoti"]
        // }
        //else if(data && data["user"]){
        // alert('bbb')
        // }
        // });
        var _this = this;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.titleService = titleService;
        this.translateService = translateService;
        this.i18nService = i18nService;
        this.util = util;
        this.user = user;
        this.Auth = Auth;
        this.socketService = socketService;
        this.idle = idle;
        this.keepalive = keepalive;
        this.idleState = 'Not started.';
        this.timedOut = false;
        this.lastPing = null;
        this.messages = [];
        this.socialNoti = "";
        this.chatbotNoti = "";
        // sets an idle timeout of 5 seconds, for testing purposes.
        idle.setIdle(environment.timeoutIdleMinute * 60);
        // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
        idle.setTimeout(environment.timeoutIdleMinute * 60);
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
        idle.onIdleEnd.subscribe(function () {
            _this.idleState = 'No longer idle.';
            console.log(_this.idleState);
            _this.reset();
        });
        idle.onTimeout.subscribe(function () {
            var dataobj = {};
            _this.idleState = 'Timed out!';
            console.log(_this.idleState);
            _this.PortalUser = JSON.parse(localStorage.getItem("dpa_portal"));
            if (_this.PortalUser != null || _this.PortalUser.contactid != null || _this.PortalUser.contactid != "") {
                _this.timedOut = true;
                _this.util.WarningDialog("ท่านถูก logout จากระบบ เนื่องจากไม่มีการใช้งาน ภายในเวลา 60 นาที");
                _this.logout();
            }
        });
        idle.onIdleStart.subscribe(function () {
            _this.idleState = 'You \'ve gone idle!';
            console.log(_this.idleState);
            //this.childModal.show();
        });
        idle.onTimeoutWarning.subscribe(function (countdown) {
            //this.idleState = 'You will time out in ' + countdown + ' seconds!'
            //console.log(this.idleState);
        });
        // sets the ping interval to 15 seconds
        keepalive.interval(15);
        keepalive.onPing.subscribe(function () { return _this.lastPing = new Date(); });
        this.reset();
    }
    AppComponent.prototype.ngOnInit = function () {
        // Setup logger
        if (environment.production) {
            Logger.enableProductionMode();
        }
        log.debug('init');
        // Setup translations
        this.i18nService.init(environment.defaultLanguage, environment.supportedLanguages);
        //connect to socket
        //this.socketService.setupSocketConnection();
    };
    AppComponent.prototype.ngOnDestroy = function () {
        //prevent memory leak when component destroyed
        this._subscription.unsubscribe();
    };
    AppComponent.prototype.reset = function () {
        this.idle.watch();
        this.idleState = 'Started.';
        this.timedOut = false;
    };
    AppComponent.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dataobj, data;
            return __generator(this, function (_a) {
                dataobj = {};
                dataobj["member_no"] = this.util.GetUserID();
                data = this.user.logout();
                if (data.status) {
                    //  await this.apiService.postnotauthen('account', 'DeleteUserSession', dataobj);
                    this.Auth.setLoggedIn(false);
                    window.location.reload();
                }
                else {
                }
                return [2 /*return*/];
            });
        });
    };
    return AppComponent;
}());
export { AppComponent };



// WEBPACK FOOTER //
// ./src/app/app.component.ts.pre-build-optimizer.js